import { create } from 'zustand';
import { telemetry } from '../../utils/telemetry';

/** UI surface that opened the bridge — recorded on the `onboarding_bridge_*` events. */
export type BridgeSource = 'deposit_panel' | 'fund_menu' | 'mobile_drawer';

export interface BridgeCheckoutCallbacks {
  onSuccess?: (result: unknown) => void;
  onClose?: (result: unknown) => void;
  source?: BridgeSource;
}

interface BridgeCheckoutState {
  // Bumping id is what tells the lazily-mounted funkit host (funkit_host.tsx) to begin a checkout.
  request: (BridgeCheckoutCallbacks & { id: number }) | null;
  requestCheckout: (callbacks: BridgeCheckoutCallbacks) => void;
}

export const useBridgeCheckoutStore = create<BridgeCheckoutState>((set) => ({
  request: null,
  requestCheckout: (callbacks) => {
    // Logged on intent rather than funkit's onOpen so a failed lazy-chunk load still shows as a drop-off.
    telemetry.logOnboarding('bridge_opened', { source: callbacks.source });
    set((state) => ({ request: { ...callbacks, id: (state.request?.id ?? 0) + 1 } }));
  },
}));
